import { z } from "zod";

export const GAME_STATUSES = ["COMING_SOON", "LIVE", "DISABLED", "MAINTENANCE"] as const;
export const gameStatusSchema = z.enum(GAME_STATUSES);

export const GAME_CATEGORIES = ["ARCADE", "CASINO"] as const;
export const gameCategorySchema = z.enum(GAME_CATEGORIES);

/**
 * Mirrors @jaiho/game-engine's GameModuleMetadata as a wire DTO. Defined
 * independently here (rather than importing game-engine) to keep the
 * dependency direction one-way: game-engine depends on shared, not the
 * reverse.
 */
export const gameCatalogueEntrySchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  shortDescription: z.string(),
  description: z.string(),
  status: gameStatusSchema,
  category: gameCategorySchema,
  featured: z.boolean(),
  sortOrder: z.number().int(),
  minBet: z.number().int(),
  maxBet: z.number().int(),
  thumbnailKey: z.string(),
});

export type GameCatalogueEntry = z.infer<typeof gameCatalogueEntrySchema>;

export const announcementSchema = z.object({
  title: z.string(),
  body: z.string(),
});

export type AnnouncementDTO = z.infer<typeof announcementSchema>;

/** GET /api/v1/config — public, non-secret runtime configuration for the client. */
export const publicConfigSchema = z.object({
  economy: z.object({
    starterBalanceCredits: z.number().int(),
    dailyRewardCredits: z.number().int(),
    dailyRewardXp: z.number().int(),
  }),
  chat: z.object({
    messageMaxLength: z.number().int(),
  }),
  /** IANA timezone owning "game day" boundaries (daily reward/streak eligibility). Display use only — the server always decides eligibility itself. */
  gameDayTimezone: z.string(),
  announcement: announcementSchema.nullable(),
  games: z.array(gameCatalogueEntrySchema),
  featureFlags: z.record(z.boolean()),
});

export type PublicConfig = z.infer<typeof publicConfigSchema>;
